import directingData from "../data/directingData";
import ProductionCard from "../components/ProductionCard";

function Directing() {
  return (
    <div className="page">
      <h1>Directing</h1>

      {directingData.map((item, index) => (
        <ProductionCard key={index} item={item} />
      ))}
    </div>
  );
}

export default Directing;